class Video {
  button;
  constructor() {
    this.button = document.querySelectorAll('[data-trigger="player-video"]')
    if(this.button){
      this._init();
    }
  }
  _init() {
    this.button.forEach(element => {
      element.addEventListener('click', () => {
        const parent = element.parentNode.parentNode;
        const heightParent = parent.offsetHeight;

        const iframe = parent.querySelector('iframe')
        const img : HTMLElement = parent.querySelector(".video__img")

        const dataSrc = iframe.getAttribute('data-src');
        iframe.setAttribute('src', dataSrc);

        iframe.style.display = 'block';
        img.style.display = 'none';
        // iframe.style.height = heightParent+'px';
      });
    });
  }
}
export const video = new Video();
